@use '@fukuri-admins/ui/layout' as *;

.textAreaElement {
  display: block;
  width: 100%;
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;

  border: 1px solid border('Quaternary');
  color: text('Middle');
  padding: spacing('4') spacing('12');
  border-radius: borderRadius('sm');
  resize: vertical;
  min-height: 44px;

  &::placeholder {
    font-size: 14px;
    line-height: 18px;
    font-weight: 400;
    color: text('Placeholder');
  }

  &:focus-within {
    outline: none;
    box-shadow: 0 0 0 3px border('Focus');
  }
}

.error {
  border-color: border('Red_Darken');
}
